import moment from 'moment';

export function getBearerToken() {
  return JSON.parse(localStorage.getItem('token'))?.token;
}
// export const UserName = JSON?.parse(localStorage?.getItem('token'))?.name;
// export const UserImage = JSON?.parse(localStorage?.getItem('token'))?.image;
// export const UserID = JSON?.parse(localStorage?.getItem('token'))?.user_id;
// export const AgentID = JSON?.parse(localStorage?.getItem('token'))?.agent_id;
// export const UserRole = JSON?.parse(localStorage?.getItem('token'))?.role;
export const API_BASE_URL = 'https://api.nujoomalfalak.com/api';
export const API_BASE_URL_Main = 'https://api.nujoomalfalak.com/';
export const BRAND_NAME = 'Nujoom Alfalak Travel & Tourism llc';
export const BRAND_ADDRESS = 'Main Entrance Gate no 2 Office 8A Bolan Block Dc Colony, GRW';
export const BRAND_PHONE = '+92 305 7543000';
export const BRAND_EMAIL = 'groups@nujoomalfalak.com';

// LoadingState.js

let loadingState = {
  isLoading: false,
  loadingKey: '',
};

export const setLoadingState = (status, key = '') => {
  // console.log("setLoadingState", status, key);
  loadingState.isLoading = status;
  loadingState.loadingKey = key;
};

export const getLoadingState = () => {
  // console.log('in get', loadingState);
  return loadingState;
};


export function calculateDuration(startDate, endDate) {
  const start = moment(startDate, 'YYYY-MM-DD');
  const end = moment(endDate, 'YYYY-MM-DD');
  const duration = moment.duration(end.diff(start));
  const years = duration.asYears();
  return years;
}

// export function formatDate(inputDate) {
//   const months = [
//     'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
//     'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
//   ];
//   // Assume inputDate is in 'YYYY-MM-DD HH:mm:ss' format
//   const dateParts = inputDate?.split(' ')[0]?.split('-');
//   const year = dateParts[0];
//   const month = months[parseInt(dateParts[1], 10) - 1];
//   const day = parseInt(dateParts[2], 10);
//   return `${day} ${month}, ${year}`;
// }

export function formatDate(inputDate) {
  if (!inputDate || typeof inputDate !== 'string') {
    return 'Invalid Date';
  }

  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  
  try {
    const dateParts = inputDate?.split(' ')[0]?.split('-');
    
    // Add validation
    if (!dateParts || dateParts.length !== 3) {
      return 'Invalid Date';
    }
    
    const year = dateParts[0];
    const month = months[parseInt(dateParts[1], 10) - 1];
    const day = parseInt(dateParts[2], 10);
    
    // Check if month exists
    if (!month || isNaN(day)) {
      return 'Invalid Date';
    }
    
    return `${day} ${month}, ${year}`;
  } catch (error) {
    return 'Error';
  }
}

export function formatDateAndTime(dateString) {
  const currentDate = new Date();
  const inputDate = new Date(dateString);
  const timeDifference = currentDate - inputDate;

  const seconds = Math.floor(timeDifference / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);
  const months = Math.floor(days / 30);

  if (months > 0) {
    return `${months} month${months > 1 ? 's' : ''} ago`;
  } else if (days > 0) {
    return `${days} day${days > 1 ? 's' : ''} ago`;
  } else if (hours > 0) {
    return `${hours} hour${hours > 1 ? 's' : ''} ago`;
  } else if (minutes > 0) {
    return `${minutes} minute${minutes > 1 ? 's' : ''} ago`;
  } else {
    return `${seconds} second${seconds > 1 ? 's' : ''} ago`;
  }
}

export function toCapitalCase(str) {
  // Split the string into words
  // console.log('str',str);
  const words = str?.split(' ');
  // console.log('str',words);

  // Capitalize the first letter of each word
  const capitalizedWords = words?.map((word) => {
    return word?.charAt(0)?.toUpperCase() + word?.slice(1);
  });

  // Join the words back together with spaces
  return capitalizedWords.join(' ');
}

export const handleMouseWheel = (e) => {
  e.target.blur();
};

export   const pickTimeWithAMPM = (dateTimeString) => {
  const date = new Date(dateTimeString);
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const ampm = hours >= 12 ? 'PM' : 'AM';
  const formattedHours = hours % 12 || 12; // Convert to 12-hour format

  // Construct the time string with AM/PM
  const timeString = `${formattedHours}:${minutes < 10 ? '0' : ''}${minutes} ${ampm}`;

  return timeString;
};


export const countries = [
  "Afghanistan",
  "Albania",
  "Algeria",
  "Andorra",
  "Angola",
  "Antigua and Barbuda",
  "Argentina",
  "Armenia",
  "Australia",
  "Austria",
  "Azerbaijan",
  "Bahamas",
  "Bahrain",
  "Bangladesh",
  "Barbados",
  "Belarus",
  "Belgium",
  "Belize",
  "Benin",
  "Bhutan",
  "Bolivia",
  "Bosnia and Herzegovina",
  "Botswana",
  "Brazil",
  "Brunei",
  "Bulgaria",
  "Burkina Faso",
  "Burundi",
  "Cabo Verde",
  "Cambodia",
  "Cameroon",
  "Canada",
  "Central African Republic",
  "Chad",
  "Chile",
  "China",
  "Colombia",
  "Comoros",
  "Congo, Democratic Republic of the",
  "Congo, Republic of the",
  "Costa Rica",
  "Cote d'Ivoire",
  "Croatia",
  "Cuba",
  "Cyprus",
  "Czech Republic",
  "Denmark",
  "Djibouti",
  "Dominica",
  "Dominican Republic",
  "Ecuador",
  "Egypt",
  "El Salvador",
  "Equatorial Guinea",
  "Eritrea",
  "Estonia",
  "Eswatini",
  "Ethiopia",
  "Fiji",
  "Finland",
  "France",
  "Gabon",
  "Gambia",
  "Georgia",
  "Germany",
  "Ghana",
  "Greece",
  "Grenada",
  "Guatemala",
  "Guinea",
  "Guinea-Bissau",
  "Guyana",
  "Haiti",
  "Honduras",
  "Hungary",
  "Iceland",
  "India",
  "Indonesia",
  "Iran",
  "Iraq",
  "Ireland",
  "Israel",
  "Italy",
  "Jamaica",
  "Japan",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "Kiribati",
  "Korea, North",
  "Korea, South",
  "Kuwait",
  "Kyrgyzstan",
  "Laos",
  "Latvia",
  "Lebanon",
  "Lesotho",
  "Liberia",
  "Libya",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  "Madagascar",
  "Malawi",
  "Malaysia",
  "Maldives",
  "Mali",
  "Malta",
  "Marshall Islands",
  "Mauritania",
  "Mauritius",
  "Mexico",
  "Micronesia",
  "Moldova",
  "Monaco",
  "Mongolia",
  "Montenegro",
  "Morocco",
  "Mozambique",
  "Myanmar",
  "Namibia",
  "Nauru",
  "Nepal",
  "Netherlands",
  "New Zealand",
  "Nicaragua",
  "Niger",
  "Nigeria",
  "North Macedonia",
  "Norway",
  "Oman",
  "Pakistan",
  "Palau",
  "Palestine",
  "Panama",
  "Papua New Guinea",
  "Paraguay",
  "Peru",
  "Philippines",
  "Poland",
  "Portugal",
  "Qatar",
  "Romania",
  "Russia",
  "Rwanda",
  "Saint Kitts and Nevis",
  "Saint Lucia",
  "Saint Vincent and the Grenadines",
  "Samoa",
  "San Marino",
  "Sao Tome and Principe",
  "Saudi Arabia",
  "Senegal",
  "Serbia",
  "Seychelles",
  "Sierra Leone",
  "Singapore",
  "Slovakia",
  "Slovenia",
  "Solomon Islands",
  "Somalia",
  "South Africa",
  "South Sudan",
  "Spain",
  "Sri Lanka",
  "Sudan",
  "Suriname",
  "Sweden",
  "Switzerland",
  "Syria",
  "Taiwan",
  "Tajikistan",
  "Tanzania",
  "Thailand",
  "Timor-Leste",
  "Togo",
  "Tonga",
  "Trinidad and Tobago",
  "Tunisia",
  "Turkey",
  "Turkmenistan",
  "Tuvalu",
  "Uganda",
  "Ukraine",
  "United Arab Emirates",
  "United Kingdom",
  "United States",
  "Uruguay",
  "Uzbekistan",
  "Vanuatu",
  "Vatican City",
  "Venezuela",
  "Vietnam",
  "Yemen",
  "Zambia",
  "Zimbabwe"
];